import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import * as Constants from '../../constants';
import { getInDomain } from '../../domains/externalUtils';
import * as Utils from '../../utils';
import RowItem from '../lib/RowItem/RowItem';
import RightsChecker from '../RightsChecker/RightsChecker';

class CatalogRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    playResumeSource: PropTypes.func.isRequired,
    pauseTrack: PropTypes.func.isRequired,
    rightsCheckerFunc: PropTypes.func.isRequired,
    blankItem: PropTypes.bool,
    isRadioOnly: PropTypes.bool,
    isPlayingCurrently: PropTypes.bool,
    index: PropTypes.number,
    sortOrder: PropTypes.string,
    collectedTrackCount: PropTypes.number,
    isPaused: PropTypes.bool,
    isUnavailable: PropTypes.bool,
    isRetired: PropTypes.bool,
    pandoraType: PropTypes.string,
    isExplicit: PropTypes.bool,
    isClean: PropTypes.bool,
    dominantColor: PropTypes.string,
    mainTextUrl: PropTypes.string,
    sourceType: PropTypes.string,
    stationId: PropTypes.string,
    isNegativeFeedback: PropTypes.bool, // cspell:disable-line
    pandoraId: PropTypes.string,
  };

  static contextType = Utils.Context.AppContext;

  componentEventLogHandler = ({ componentEventType, destinationUrl }) => {
    const clickEventData = this.context.integration.getActionData({
      pandoraId: this.props.id,
      currentIndex: this.props.index,
      componentEventType,
      destinationUrl,
    });
    this.context.integration.action.clicked(clickEventData);
  };

  onPlayClick = () => {
    const { id, pandoraType, sortOrder, sourceType, stationId, pandoraId } = this.props;

    let index;
    let type = pandoraType;
    let sourceId = id;

    this.props.rightsCheckerFunc();

    if (
      ![
        Constants.SourceTypes.PandoraTypes.SONG,
        Constants.SourceTypes.PandoraTypes.EPISODE,
      ].includes(pandoraType)
    ) {
      index = this.props.index;
    }

    if (Utils.SourceType.isPseudoSource(sourceType)) {
      type = Constants.SourceTypes.PandoraTypes.STATION_THUMB_UP;
      sourceId = Utils.SourceType.getStationFeedbackPseudoId(stationId);
      index = this.props.index;
    }

    const playSourceUsingPandoraId = type === Constants.SourceTypes.PandoraTypes.COLLECTED_TRACKS;

    this.props.playResumeSource({
      id: sourceId,
      pandoraId,
      playSourceUsingPandoraId,
      pandoraType: type,
      index,
      sortOrder,
    });
    this.componentEventLogHandler({
      componentEventType: Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
    });
  };

  onPauseClick = () => {
    this.props.pauseTrack();
    this.componentEventLogHandler({
      componentEventType: Constants.AudioPlayer.AudioPlayerActions.PAUSE,
    });
  };

  onLinkClick = e => {
    this.componentEventLogHandler({ destinationUrl: e.currentTarget.pathname });
  };

  render() {
    if (this.props.blankItem) return <RowItem isPlaceholder={true} />;
    return (
      <RowItem
        // cspell:disable-next-line
        playButtonOnclick={this.props.isNegativeFeedback ? null : this.onPlayClick}
        pauseButtonOnclick={this.onPauseClick}
        mainTextOnclick={this.props.mainTextUrl && this.onLinkClick}
        isPlaying={this.props.isPlayingCurrently && !this.props.isPaused && !this.props.isRetired}
        isPaused={this.props.isPaused}
        isDisabled={this.props.isRadioOnly || this.props.isUnavailable || this.props.isRetired}
        isExplicit={this.props.isExplicit}
        isClean={this.props.isClean}
        {...this.props}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const pathname = Utils.Route.getCurrentPathnameFromState(state);
  props.isPaused =
    !getInDomain('playback.utils.isAudioPlaying', false)(state) && ownProps.isPlayingCurrently;
  if (
    ownProps.pandoraType === Constants.SourceTypes.PandoraTypes.SONG &&
    Utils.Route.isCollectionSongsPath(pathname, true)
  ) {
    props.id = Utils.SourceType.getCollectedTrackPseudoId(
      Utils.Listener.getCurrentListenerIdFromState(state),
    );
    props.pandoraType = Constants.SourceTypes.PandoraTypes.COLLECTED_TRACKS;
    props.index = getInDomain('collection.utils.getIndexOfTrack', null)(state, ownProps.id);
  } else if (ownProps.collectedTrackCount) {
    props.id = Utils.SourceType.getCollectedAlbumTracksId(ownProps.id);
    props.pandoraType = Constants.SourceTypes.PandoraTypes.COLLECTED_ALBUM_TRACKS;
  }
  return props;
}

const mapDispatchToProps = {
  playResumeSource: Actions.UseCases.playResumeSource,
  pauseTrack: Actions.UseCases.pauseTrack,
};

export default RightsChecker(connect(mapStateToProps, mapDispatchToProps)(CatalogRowItem));
